import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/ipe/workbench/ipe-workbench.css';
import IpeConfirmDialog from '@/components/ipe/IpeConfirmDialog';
import { buildCreditActionHint } from '@/constants/ipeCredits';

/**
 * 操作前确认（展示将消耗的 IPE 豆，单价来自定价配置）
 * @returns {Promise<boolean>}
 */
export function confirmIpeCreditAction({
  navId,
  imageCount = 1,
  title = '确认操作',
  confirmLabel = '确认',
  cancelLabel = '取消',
}) {
  const message = buildCreditActionHint(navId, imageCount) || '确认继续？';

  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const cleanup = () => {
      root.unmount();
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };

    const finish = (value) => {
      cleanup();
      resolve(value);
    };

    function CreditConfirmHost() {
      const [open, setOpen] = useState(true);

      const handleClose = (value) => {
        setOpen(false);
        finish(value);
      };

      return (
        <IpeConfirmDialog
          open={open}
          title={title}
          message={message}
          confirmLabel={confirmLabel}
          cancelLabel={cancelLabel}
          onCancel={() => handleClose(false)}
          onConfirm={() => handleClose(true)}
        />
      );
    }

    root.render(<CreditConfirmHost />);
  });
}
